import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-281ef6e3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "activation" }
const _hoisted_2 = {
  key: 0,
  class: "activation"
}
const _hoisted_3 = { style: {"font-size":"28px"} }
const _hoisted_4 = { style: {"font-size":"28px"} }
const _hoisted_5 = { style: {"color":"#027DB4"} }
const _hoisted_6 = { style: {"margin-top":"50px"} }
const _hoisted_7 = {
  key: 1,
  class: "activation"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { style: {"display":"flex","align-items":"center","font-size":"18px"} }
const _hoisted_11 = {
  key: 2,
  class: "activation"
}
const _hoisted_12 = { style: {"font-size":"28px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_check_circle_outlined = _resolveComponent("check-circle-outlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_loading_outlined = _resolveComponent("loading-outlined")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_exclamation_circle_outlined = _resolveComponent("exclamation-circle-outlined")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isflag)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, [
            _createVNode(_component_check_circle_outlined, { class: "icon-t" }),
            _createTextVNode(_toDisplayString(_ctx.t('page.activationemail.txtone')), 1)
          ]),
          _createElementVNode("p", _hoisted_4, [
            _createTextVNode(_toDisplayString(_ctx.t('page.activationemail.txtstart')) + " ", 1),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.t('page.activationemail.txttime')), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.t('page.activationemail.txtend')), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_a_space, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: _ctx.handleBack
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('page.activationemail.btnback')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: _ctx.handleGoToEmail
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('page.activationemail.gotoemail')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isFlag)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_ctx.isCheck)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("p", null, "您正在找回的账号是:" + _toDisplayString(_ctx.email), 1),
                _createVNode(_component_a_form, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, _mergeProps({ label: "" }, _ctx.validateInfos.newPassword), {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input_password, {
                          value: _ctx.modelRef.newPassword,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modelRef.newPassword) = $event)),
                          placeholder: "请设置新密码"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }, 16),
                    _createVNode(_component_a_form_item, _mergeProps({ label: "" }, _ctx.validateInfos.newPassword2), {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input_password, {
                          value: _ctx.modelRef.newPassword2,
                          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modelRef.newPassword2) = $event)),
                          placeholder: "确认新密码"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }, 16),
                    _createVNode(_component_a_row, { style: {"display":"flex","justify-content":"center","width":"100%"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_space, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_button, {
                              type: "primary",
                              onClick: _ctx.handleSubmit
                            }, {
                              default: _withCtx(() => [
                                (_ctx.loading)
                                  ? (_openBlock(), _createBlock(_component_loading_outlined, { key: 0 }))
                                  : _createCommentVNode("", true),
                                _createTextVNode("确定 ")
                              ]),
                              _: 1
                            }, 8, ["onClick"]),
                            _createVNode(_component_a_button, { onClick: _ctx.resetFields }, {
                              default: _withCtx(() => [
                                _createTextVNode("重置")
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_10, [
                      _createVNode(_component_exclamation_circle_outlined, { style: {"color":"red","font-size":"26px","margin-right":"10px"} }),
                      _createTextVNode("链接错误，校验失败！ ")
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, {
                  justify: "center",
                  style: {"margin-top":"20px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_space, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          onClick: _ctx.handleBack,
                          type: "primary"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("返回")
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]))
        ]))
      : _createCommentVNode("", true),
    (_ctx.isShow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("p", _hoisted_12, [
            _createVNode(_component_check_circle_outlined, { class: "icon-t" }),
            _createTextVNode("密码修改成功，等待" + _toDisplayString(_ctx.count) + "秒钟会自动跳转到登陆页面……", 1)
          ]),
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: _ctx.handleBack
          }, {
            default: _withCtx(() => [
              _createTextVNode("登录")
            ]),
            _: 1
          }, 8, ["onClick"])
        ]))
      : _createCommentVNode("", true)
  ]))
}